export default __webpack_public_path__ + "static/media/homeActive.b722cb12.svg";